import { TTagState } from '@/redux/reducers/tag';
import { TGetTagsSuccess } from '@/redux/actions/tag';

export const getTagsUpdateState = (state: TTagState, action: TGetTagsSuccess): TTagState => ({
  ...state,
  getTagsResponse: action.payload.response,
});
